<template lang="pug">
el-dialog(
  lock-scroll
  :custom-class='`app-${upDialog.type} ${upDialog.customClass}`'
  :visible='upDialog.visible'
  :title='upDialog.title'
  :top='upDialog.top'
  :width='upDialog.width'
  :before-close="beforeCancel"
  :close-on-click-modal='upDialog.closeOnClickModal')
  component(:is='upDialog.component' :key='upDialog.key')
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dialogCommon } from '@/mixin'
export default {
  name: 'app-upDialog',
  mixins: [ dialogCommon ],
  computed: {
    ...mapState('home', ['upDialog']),
  },
  methods: {
    ...mapActions('home', ['changeGlobalUpDialog']),
    beforeCancel () {
      this.upDialogHide()
    },
  },
}
</script>

<style>

</style>
